<div (keydown)="onKeyDown($event)" class="custom-select" tabindex="0">

  <div class="chips-select-container">

    <div (click)="isDisabled === false ? toggleDropdown() : null" class="select-display">
      @switch (true) {
        @case (selectedCount === 0) {
          <span>{{ placeholder }}</span>
        }
        @case (selectedCount > 0 && (showChips || allowMultiple) && !storesHeaderDropdown) {
          <span>{{ selectedCount }} Selected</span>
        }
        @case (selectedCount > 0 && allowMultiple && storesHeaderDropdown) {
          <span class="make-flex">
            <app-display-icon
              [icon]="icons.storeOutline"
              class="store-icon">
            </app-display-icon>
            {{ headerStoreSelectionLabel }}
          </span>
        }
        @case (showTitle) {
          <span class="make-flex">
            <app-display-icon [icon]="setIcon" [colour]="setIconColour"></app-display-icon>
            {{ placeholder }}</span>
        }
        @default {
          <span class="make-flex store-selector">
            @if (showStoreIcon) {
              <app-display-icon
                [icon]="icons.storeOutline"
                class="store-icon">
              </app-display-icon>
            }

            {{ options[firstSelectedOption]?.name || firstSelectedOption }}
            @if (showFreshnessIndicator) {
              <app-shared-freshness-indicator-container
                [currentStore]="stores[firstSelectedOption]"
                [dataType]="dataTimeStampKey[0]"
                class="freshness-button">
                </app-shared-freshness-indicator-container>
            }
          </span>
        }
      }
      <i [class.open]="isDropdownOpen" class="arrow"></i>
    </div>

    @if (showChips) {
      <div appHorizontalScroll class="chips-container">
        @for (key of optionKeys; track key; let i = $index) {
          @if (options[key].selected) {
            <app-shared-chip
              (click)="!options[key].disabled && removeChip(key, $event)"
              [isChipDisabled]="options[key].disabled"
              [isChipSelected]="true">
              <div>{{ options[key].name }}</div>
              @if (!options[key].disabled) {
                <app-display-icon
                  [icon]="icons.closeCircle">
                </app-display-icon>
              }
            </app-shared-chip>
          }
        }
      </div>
    }

  </div>

  @if (isDropdownOpen) {
    <div (click)="$event.stopPropagation()" [@dropdownAnimation] [@.disabled]="floatDropdown"
      [class.dropdown-above]="!floatDropdown && dropdownPosition === 'above'"
      [class.dropdown-floating]="floatDropdown"
      class="dropdown-panel">
      @if (
        (allowMultiple && allowSelectAll && !storesHeaderDropdown) ||
        showSearchBar ||
        canAddNewOption ||
        setDefault ||
        (allowMultiple && storesHeaderDropdown)
        ) {
        <div class="header">
        @if (allowMultiple && allowSelectAll && !storesHeaderDropdown) {
          <input
            (click)="onToggleAll($event)"
            [checked]="selectAllCheckBox.isAllSelected"
            [indeterminate]="selectAllCheckBox.isSomeSelected"
            type="checkbox"/>
        }
        @if (showSearchBar) {
          <input (input)="onSearchChange()" [(ngModel)]="searchText" [placeholder]="searchPlaceholder" [maxlength]="maxLength" type="text"/>
        }
        @if (canAddNewOption) {
          <button
            class="add-new-button"
            (click)="addNewOption(); $event.stopPropagation()"
            type="button">
            <app-display-icon
              [icon]="icons.plus"
              [colour]="iconColourEnum.secondary">
            </app-display-icon>
            Add "{{ searchText }}"
          </button>
        }
        @if (setDefault) {
          <app-shared-button
            class="default-button"
            (click)="onDefaultClick(); $event.stopPropagation()"
            [colour]="iconColourEnum.secondary"
            [disabled]="false"
            [fill]="false">
            Default
          </app-shared-button>
        }

        @if (allowMultiple && storesHeaderDropdown) {
          @if (allowSelectAll) {
            <input
              (click)="onToggleAll($event)"
              [checked]="selectAllCheckBox.isAllSelected"
              [indeterminate]="selectAllCheckBox.isSomeSelected"
              type="checkbox"/>
          }
          <span class="header-text">{{ isEverySelectableStoreSelected ? 'All stores' : headerStoreSelectionLabel }}</span>
        }

      </div>
      }
      <div class="options-container">
        <ul>
          @for (key of filteredOptionKeys; track key; let i = $index) {
            <li
              (click)="toggleOption(key, $event)"
              [matTooltip]="currentOptions[key].tooltip || ''"
              [matTooltipDisabled]="!currentOptions[key].tooltip"
              matTooltipPosition="right"
              [class.disabled]="currentOptions[key].disabled"
              [class.highlighted]="highlightedIndex === i"
              [class.selected]="currentOptions[key].selected">
              @if (showCheckbox) {
                <input
                  [checked]="currentOptions[key].selected"
                  [disabled]="currentOptions[key].disabled"
                  type="checkbox"/>
              } @else if (storesHeaderDropdown || showStoreIcon) {
                <app-display-icon
                  [icon]="icons.storeOutline"
                  class="store-icon">
                </app-display-icon>
              }
              <span class="dropdown-panel-text">{{ currentOptions[key].name }}</span>
              @if (currentOptions[key].colour) {
                <div
                  class="colour-square"
                  [style.background-color]="currentOptions[key].colour">
                </div>
              }
              @if (showFreshnessIndicator && !currentOptions[key].disabled) {
                <app-shared-freshness-indicator-container
                  [currentStore]="stores[key]"
                  [dataType]="dataTimeStampKey[0]"
                  class="freshness-button">
                </app-shared-freshness-indicator-container>
              }
              @if (showToolTips) {
                <app-display-icon class="tooltip-icon"
                                  [icon]="icons.infoSlabCircleOutline"
                                  [title]="toolTips[key]"
                                  [tooltip]="toolTips[key]">
                </app-display-icon>
              }
            </li>
          }
        </ul>
      </div>
      @if (showActionButtons) {
        <div class="action-buttons">
          @if (saveLoad) {
            <app-shared-button
              class="default-button"
              (click)="onSaveLoadClick(); $event.stopPropagation()"
              [colour]="iconColourEnum.secondary"
              [disabled]="false"
              [fill]="false">
              Save/Load
            </app-shared-button>
          }
          <app-shared-button
            (click)="cancelSelection(); $event.stopPropagation()"
            [colour]="iconColourEnum.secondary"
            [disabled]="false"
            [fill]="false">
            Cancel
          </app-shared-button>
          <app-shared-button
            (click)="confirmSelection(); $event.stopPropagation()"
            [colour]="iconColourEnum.secondary"
            [disabled]="false"
            [fill]="true">
            Confirm
          </app-shared-button>
        </div>
      }
    </div>
  }

</div>
